var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('span',{class:("stamp stamp-sm bg-" + _vm.color + " mr-3")},[_c('i',{class:("fa fa-" + _vm.icon)})]),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4287a85a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/asset-register/IconizedInfoComponent.vue
// module id = 1GTs
// module chunks = 0